import { QueryCache } from 'react-query'
import { dehydrate, DehydratedState, hydrate } from 'react-query/hydration'

declare global {
  interface Window {
    __dehydrateQueries: () => DehydratedState
  }
}

/**
 * Fills the cache from the `#prerendered-queries` script a prerendered page carries,
 * so the first render shows the same content as the HTML instead of a loading line.
 * Call once, before the first render. A page without the script, or with broken JSON, is left alone.
 */
export function hydratePrerenderedQueries(queryCache: QueryCache): void {
  const script = document.getElementById('prerendered-queries')
  if (!script?.textContent) {
    return
  }

  try {
    hydrate(queryCache, JSON.parse(script.textContent))
  } catch {
    // Without data the app fetches as usual.
  }
}

/**
 * Lets the prerender script read the cache through `window.__dehydrateQueries()`
 * and embed it in the page it writes.
 */
export function exposeQueryCache(queryCache: QueryCache): void {
  window.__dehydrateQueries = () => dehydrate(queryCache)
}
